import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  tabWrapper: {
    marginBottom: SPACES.xxl,

    display: 'flex',
    gap: SPACES.xl,
    alignItems: 'center',

    [theme.breakpoints.down('tablet')]: {
      justifyContent: 'space-between',
    },
  },
  toggleGroup: {
    '&&': {
      '& > button': {
        borderBottom: 0,
        borderTop: 0,

        '&:first-of-type': {
          borderLeft: 0,
        },
        '&:not(:first-of-type)': {
          borderRight: 0,
        },
      },
    },
  },
  hideIconBtn: {
    '&&': {
      [theme.breakpoints.up('tablet')]: {
        display: 'none',
      },
    },
  },
  hideBtn: {
    '&&': {
      [theme.breakpoints.down('tablet')]: {
        display: 'none',
      },
    },
  },
}))
